import { reduce } from 'lodash-es';
import { rangeCount } from '@startuptools/common/transactions';
import { type GqlShareRange } from '../../graphql/base-types.graphql';

export function getTotalNumberOfShares(ranges: Pick<GqlShareRange, 'start' | 'end'>[]): number {
  return reduce(ranges, (sum, r) => sum + rangeCount(r.start, r.end), 0);
}
